import { z } from 'zod';

/**
 * Health check response schema
 */
export const HealthCheckResponseSchema = z.object({
  status: z.string().describe('Health status of the service'),
  timestamp: z.string().describe('ISO timestamp of the health check'),
});

// Export TypeScript types
export type HealthCheckResponse = z.infer<typeof HealthCheckResponseSchema>;
